// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c6278fd3","703":"d61f4bb4","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};